import React from "react";
import DynamicSearchInput from "./BaseInputs/DynamicSearchInput";
import Util from "../../global/utils/Helpers";

export const keywordSuggestions = async (keyword) => {
  let payload = {
    search: keyword || "*",
    top: 10,
    select: "*",
    suggesterName: "socSuggester",
    searchFields: "title, code",
    orderby: "code, title",
  };

  return fetch(Util.socIndex(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((e) => e);
};

const SOCAdapter = (Component) => {
  let queryObject = {
    label: "SOC",
    searchAdapter: keywordSuggestions,
    descriptors: {
      _id: "code",
      _title: "title",
    },
  };
  return class Default extends React.Component {
    render() {
      return <Component {...queryObject} {...this.props} />;
    }
  };
};
export default SOCAdapter(DynamicSearchInput);
